<template>
  <div>
    <div class="relative ml-2 inline-block align-middle top-1">
      <input
        v-if="isArray != null"
        :name="name" 
        type="checkbox" 
        v-model="isArray"
        :value="name"
        class="appearance-none bg-opacity-25 h-indigo-checkbox w-indigo-checkbox 
        focus:outline-none focus:outline-indigo border-gray-600
        border-2 rounded "
        :necessary="necessary"
      >      
      <input
        v-else
        :name="name" 
        type="checkbox" 
        v-model="mutableValue"
        class="appearance-none bg-opacity-25 h-indigo-checkbox w-indigo-checkbox 
        focus:outline-none focus:outline-indigo border-gray-600
        border-2 rounded "
        :necessary="necessary"
      >
      
      <div class="pointer-events-none absolute inset-x-1 inset-y-1.5">
        <icon
          name="checkmark"
          width="12px"
          height="8px"
          class="font-semibold text-gray-600 "
          v-if="mutableValue"
        />
      </div>
    </div>

    <label
      :for="name" 
      v-if="libelle != null"
      :class="'text-2sm sm:text-'+sizeText+' text-'+colorText+' font-'+weightText+' absolute px-2 py-1'"
      @click="mutableValue=!mutableValue"
    >
      {{ libelle }}
    </label>
  </div>
</template>

<script>
import Icon from '../../components/Icon';

export default {
  components: {
    Icon
  },
  props: ['name', 'libelle', 'value', 'necessary', 'isArray', 'colorLibelle', 'sizeLibelle', 'weightLibelle'],
  data: function () {
    return {
      mutableValue: this.value,
      colorText: 'gray-900',
      sizeText: 'base',
      weightText: 'semibold',
    };
  },
  mounted(){
    if(this.colorLibelle != undefined){
      this.colorText = this.colorLibelle;
    }
    if(this.sizeLibelle != undefined){
      this.sizeText = this.sizeLibelle;
    }
    if(this.weightLibelle != undefined){
      this.weightText = this.weightLibelle;
    }
  },
  watch: {
    mutableValue() {
      this.$emit('input', this.mutableValue);
    },
    value(){
      this.mutableValue = this.value;
    }
  },
};
</script>